import TypeManager from "./TypeManager";

export default function JobTypes() {
  return (
    <TypeManager
      title="Job Types"
      subtitle="Manage custom activity/job types for time entries."
      apiPath="JobTypes"
      nameField="jobName"
      idField="id"
      feature="custom_job_types"
    />
  );
}
